/* -------------------------------------------------------------------------- */
/* Dependencies                                */
/* -------------------------------------------------------------------------- */
import { TStore } from '@store/index';
import { StateCreator } from 'zustand';

/* -------------------------------------------------------------------------- */
/* Interface                                 */
/* -------------------------------------------------------------------------- */
export interface IOffsetAddSlice {
	isOpenModalCancelAddOffset: boolean;
	isAddOffset: boolean;
	setIsAddOffset: (_isAddOffset: boolean) => void;
	currentStepOffsetCreate: number;
	setCurrentStepOffsetCreate: (
		_currentStepOffsetCreate: number
	) => void;

	// States pour les Drawers
	openDrawerOrganization: boolean;
	setOpenDrawerOrganization: (open: boolean) => void;
	setIsOpenModalCancelAddOffset: (open: boolean) => void;
	openDrawerContact: boolean;
	setOpenDrawerContact: (open: boolean) => void;
	openDrawerBrand: boolean;
	setOpenDrawerBrand: (open: boolean) => void;

	// States pour les entités créées
	createdUser: string;
	setCreatedUser: (userId: string) => void;
	createdOrganization: string;
	setCreatedOrganization: (orgId: string) => void;
	createdBrand: string;
	setCreatedBrand: (brandId: string) => void;
	selectedOrganizationId: string;
	setSelectedOrganizationId: (orgId: string) => void;
}

/* -------------------------------------------------------------------------- */
/* Slice                                   */
/* -------------------------------------------------------------------------- */

const initialState = {
	isAddOffset: false,
	currentStepOffsetCreate: 1,
	openDrawerOrganization: false,
	openDrawerContact: false,
	openDrawerBrand: false,
	createdUser: '',
	createdOrganization: '',
	createdBrand: '',
	selectedOrganizationId: '',
	isOpenModalCancelAddOffset: false,
};

export const createOffsetAddSlice: StateCreator<
	TStore,
	[],
	[],
	IOffsetAddSlice
> = (set) => ({
	...initialState,

	setIsAddOffset: (isAddOffset) => set({ isAddOffset }),

	setCurrentStepOffsetCreate: (currentStepOffsetCreate) =>
		set({ currentStepOffsetCreate }),

	// Setters pour les Drawers
	setOpenDrawerOrganization: (open) =>
		set({ openDrawerOrganization: open }),

	setOpenDrawerContact: (open) =>
		set({ openDrawerContact: open }),

	setOpenDrawerBrand: (open) =>
		set({ openDrawerBrand: open }),

	// Setters pour les entités créées
	setCreatedUser: (userId) =>
		set({ createdUser: userId }),

	setCreatedOrganization: (orgId) =>
		set({ createdOrganization: orgId }),

	setCreatedBrand: (brandId) =>
		set({ createdBrand: brandId }),

	setSelectedOrganizationId: (orgId) =>
		set({ selectedOrganizationId: orgId }),
	setIsOpenModalCancelAddOffset: (open) =>
		set({ isOpenModalCancelAddOffset: open }),
});
